export default "<fieldset [disabled]=\"formDisabled\">\n  <ng-content></ng-content>\n</fieldset>";